import React from "react"
import {Title} from "./component"

type CatalogueMarketingStyles = {
    linkColour: string
    fontWeight: string
}

export type StandardTitleContentProps = {
    children: React.ReactNode
    catalogueMarketingStyles: CatalogueMarketingStyles
    isFirstElement: boolean
}

const StandardTitleContent = ({children, catalogueMarketingStyles, isFirstElement}: StandardTitleContentProps) => (
    <Title {...catalogueMarketingStyles} isFirstElement={isFirstElement}>
        {children}
    </Title>
)

export default StandardTitleContent
